import React, { Component } from 'react';
import { BrowserRouter, Route } from "react-router-dom";
import SalesDashboard from "./Components-Sales/salesDashboard";

class App extends Component {

  render() {
        return (
      <div>
        <BrowserRouter>
          <Route exact path="/" component={SalesDashboard} />
        </BrowserRouter>
      </div>
      
    );
  }
}

export default App;
